import { ArchiveIcon } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipTrigger } from "@/components/ui/tooltip";

export function ArchivedContainerBadge() {
  return (
    <TooltipTrigger>
      <Badge color="amber" size="sm" className="inline-flex items-center gap-1">
        <ArchiveIcon data-slot="icon" className="size-3 shrink-0" />
        Archived
      </Badge>
      <Tooltip>
        This container has been archived and is hidden from accessioning.
      </Tooltip>
    </TooltipTrigger>
  );
}
